import { useState } from 'react'
import { User, Send } from "react-feather"
import Drawer from "./ui/Drawer";
import {Article, CommentSection} from "../helper/interfaces";
import {loadCommentsClientSide, postCommentsClientSide} from "../helper/api";
import { getFormattedCreationDate } from '../helper/niceTimeHelper';
import {useUser} from "../lib/useUser";
import parse, {HTMLReactParserOptions} from 'html-react-parser';
import { Element } from 'domhandler';
import TextareaAutosize from 'react-autosize-textarea';
import React from 'react';

interface CommentsDrawerNNProps {
  onClose: () => void
  data: CommentSection
  article: Article
}

interface CommentsItemProps {
  text: string
  author: string
  creationDate: string
}

const CommentsDrawerNN = ({onClose, data, article}: CommentsDrawerNNProps) => {
  const [user] = useUser()
  const tokenId = user?.tokenId || undefined
  const [loadedComments, setLoadedComments] = useState(data)
  const [resultText, setResultText] = useState('')

  const commentsCount = article.objectComments?.commentsCount
  const commentsCountString = commentsCount > 1 ? `${commentsCount} Kommentare` : commentsCount === 1 ? '1 Kommentar' : 'Keine Kommentare'

  const [page, setPage] = useState(2)

  const loadMoreComments = async () => {
    // load more data merge
    let moreComments = await loadCommentsClientSide(article.id, page)

    if (moreComments) {
      setPage(page + 1)

      const a = loadedComments.comments.concat(moreComments)
      setLoadedComments({
        ...loadedComments,
        comments: a
      })
    }
    return false
  }
  

  const postComment = async (text: string) => {
    const result = await postCommentsClientSide(article.id, text, tokenId)
    if (result?.text) {
      setResultText(result?.text)
      // setTimeout(() => {
      //   setResultText('')
      // }, 5000)
    }
  }

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if ('attribs' in domNode && domNode.attribs?.href) {
        domNode.attribs.target = "_blank";
      }
    },
  };
  
  const commentsLength = loadedComments?.comments?.length ?? 0;
  return (
    <Drawer onClose={onClose} title={commentsCountString} className="comments-drawer-content">
      <div className="comments-drawer">
        {
          <>
            {loadedComments?.comments?.length > 0 &&
              <ul>
                {loadedComments?.comments?.map((item, index) => 
                  <React.Fragment key={index}>
                    {item && item.date && (
                      <li>
                        <CommentsItem {...item} />
                      </li>
                    )}
                  </React.Fragment>
                )}
              </ul>
            }
            {commentsLength == 0 &&
              <div>Noch keine Kommentare</div>
            }

            {commentsLength < loadedComments?.commentsCount &&
              <button
                className="teasers__more__btn btn btn-primary w-full"
                onClick={() => { loadMoreComments(); }}
              >Weitere Kommentare</button>
            }
          </>
        }
      </div>
      <div className="comments-drawer__footer">
        { resultText && <div className="mb-2">{parse(resultText, options)}</div>}
        { !tokenId && <div>Um selbst einen Kommentar abgeben zu können, müssen Sie sich einloggen oder sich vorher registrieren.</div>}
        { tokenId && <CommentsInput postComment={postComment} />}
      </div>
    </Drawer>
  )
}

export const CommentsItem = ({text, author, creationDate}: CommentsItemProps) => {
  const initials = author?.split(' ')?.map(i => i[0])?.join(' ') || ''

  return (
    <div className="comments-item">
      <div className="comments-item__avatar">{initials.toUpperCase()}</div>
      <div>
        <p className="comments-item__name">{author}</p>
        <p className="comments-item__text">
          {text?.split("\n").map((line, index) => (
            <span key={index}>
              {line}
              {index < text?.split("\n").length - 1 && <br />}
            </span>
          ))}
        </p>
        { creationDate &&
          <p className="comments-item__time">{getFormattedCreationDate(creationDate)}</p>
        }
      </div>
    </div>
  )
}

interface CommentsInputProps {
  postComment: (text: string) => void
}

const CommentsInput = ({ postComment }: CommentsInputProps) => {
  const [comment, setComment] = useState('')

  const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value)
  }

  const handlePostComment = () => {
    if (!comment) return
    postComment(comment)
    setComment('')
  }

  return (
    <div className="comments-input__wrapper">
      <div className="comments-input__icon">
        <User />
      </div>
      <div className="comments-input">
        <div className="comments-input__field">
          <TextareaAutosize
           rows={2}
           maxRows={8}
          placeholder="Kommentar schreiben"
          onChange={handleInput}
          value={comment}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
          ></TextareaAutosize>
        </div>
        <button className="comments-input__action" onClick={handlePostComment}
                    aria-label="Kommentar absenden">
          <Send />
        </button>
      </div>
    </div>
  )
}

export default CommentsDrawerNN